import React from 'react';
import classnames from 'classnames';
import styled, { css } from 'styled-components';
import { COLOR, FONT_FAMILY, FONT_SIZE, LINE_HEIGHT, INPUT_PADDING } from '@latitude/core/utils/constants';
var StyledSelect = /*#__PURE__*/styled.select.withConfig({
  displayName: "Select__StyledSelect",
  componentId: "sc-vj60ik-0"
})(["appearance:none;-moz-appearance:none;text-indent:0.01px;text-overflow:'';border:", ";border-radius:0;cursor:pointer;background:", ";border-bottom:", ";outline:none;font-family:", ";color:", ";font-size:", ";line-height:", ";padding:", ";max-width:100%;background-image:url('/media/forms/chevron-grey.svg');background-size:10px 5px;background-position:center right 10px;background-repeat:no-repeat;", " &::-ms-expand{display:none;}"], function (_ref) {
  var showError = _ref.showError,
      widget = _ref.widget;
  return !widget && showError ? "1px solid " + COLOR.TEXT_ERROR : 'none';
}, function (_ref2) {
  var widget = _ref2.widget;
  return widget ? 'none' : "" + COLOR.WHITE;
}, function (_ref3) {
  var widget = _ref3.widget,
      showError = _ref3.showError;
  return widget ? showError ? "4px solid " + COLOR.TEXT_ERROR : "1px solid " + COLOR.BLUE : 'none';
}, function (_ref4) {
  var widget = _ref4.widget;
  return widget ? "" + FONT_FAMILY.TITLE : "" + FONT_FAMILY.BODY;
}, function (_ref5) {
  var cssColor = _ref5.cssColor;
  return cssColor;
}, function (_ref6) {
  var widget = _ref6.widget;
  return widget ? "20px" : "" + FONT_SIZE.NORMAL;
}, LINE_HEIGHT.STANDARD.NORMAL, function (_ref7) {
  var widget = _ref7.widget;
  return widget ? "" + INPUT_PADDING.WIDGET : "" + INPUT_PADDING.NORMAL;
}, function (_ref8) {
  var widget = _ref8.widget;
  return widget && css(["padding-right:32px;background-image:url(", ");background-position:center right 0;background-repeat:no-repeat;background-size:unset;font-weight:600;"], require('./images/chevron.svg'));
});
var StyledErrorContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Select__StyledErrorContainer",
  componentId: "sc-vj60ik-1"
})(["position:relative;padding:10px 0 0 0;text-align:", ";"], function (_ref9) {
  var widget = _ref9.widget;
  return widget ? 'left !important' : '';
});
var StyledErrorMessage = /*#__PURE__*/styled.div.withConfig({
  displayName: "Select__StyledErrorMessage",
  componentId: "sc-vj60ik-2"
})(["color:", ";"], COLOR.TEXT_ERROR);
var StyledLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "Select__StyledLabel",
  componentId: "sc-vj60ik-3"
})(["color:", ";", ""], function (_ref10) {
  var showError = _ref10.showError;
  return showError ? COLOR.TEXT_ERROR : 'inherit';
}, function (_ref11) {
  var widget = _ref11.widget;
  return widget && css(["margin-bottom:0;font-size:", ";font-weight:300;text-align:left;"], FONT_SIZE.LARGE);
});

var Select = function Select(props) {
  var id = props.id,
      label = props.label,
      placeholder = props.placeholder,
      onChange = props.onChange,
      onBlur = props.onBlur,
      name = props.name,
      selectedValue = props.selectedValue,
      values = props.values,
      className = props.className,
      showError = props.showError,
      showErrorMessage = props.showErrorMessage,
      widget = props.widget,
      _props$color = props.color,
      color = _props$color === void 0 ? COLOR.BODY : _props$color;
  var placeholderOption = '';

  if (placeholder) {
    placeholderOption = /*#__PURE__*/React.createElement("option", {
      value: "",
      key: placeholder,
      disabled: true,
      defaultValue: true
    }, placeholder);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(StyledLabel, {
    id: id + "-label",
    htmlFor: id,
    showError: !widget && showError,
    widget: widget
  }, label), /*#__PURE__*/React.createElement(StyledSelect, {
    id: id,
    cssColor: color,
    onChange: onChange,
    onBlur: onBlur,
    name: name,
    value: selectedValue,
    placeholder: placeholder,
    showError: showError,
    className: classnames('styled-select--wide', className),
    widget: widget
  }, placeholderOption, values.map(function (v) {
    return /*#__PURE__*/React.createElement("option", {
      value: v.value,
      key: v.text + '' + v.value
    }, v.text);
  })), showError && /*#__PURE__*/React.createElement(StyledErrorContainer, {
    widget: widget
  }, /*#__PURE__*/React.createElement(StyledErrorMessage, null, showErrorMessage)));
};

export default Select;